import Addresses from './Adresses'

const AddressesPage = () => {
  return (
    <div className="card p-b">
      <Addresses noSelection={true} />
    </div>
  )
}

export default AddressesPage
